import { z } from 'zod';

/**
 * In-App-Benachrichtigungen (Modul notifications). Generisch gehalten: `type`
 * klassifiziert den Anlass, `title`/`body` tragen den fertig formulierten Text,
 * `linkPath` ist das SPA-Ziel beim Klick. Erste Auslöser sind die Artikel-Anträge
 * (Engineering): neuer Antrag → Sekretariat, Freigabe/Ablehnung/Rückfrage →
 * Antragsteller. Die Werte spiegeln das Prisma-Enum `NotificationType`.
 */
export const notificationTypeSchema = z.enum([
  'ARTICLE_REQUEST_NEW',
  'ARTICLE_REQUEST_APPROVED',
  'ARTICLE_REQUEST_REJECTED',
  'ARTICLE_REQUEST_RETURNED',
  'TASK_ASSIGNED',
  'TASK_DUE_SOON',
  'TASK_OVERDUE',
  'LEAVE_REQUESTED',
  'LEAVE_DECIDED',
  'TRAVEL_REQUESTED',
  'TRAVEL_DECIDED',
  'SALES_RELEASE_REQUESTED',
  'SALES_RELEASE_APPROVED',
  'SALES_RELEASE_REJECTED',
  'SALES_RELEASE_REVOKED',
  'ADMIN_SECURITY_ACTION',
  'ROLE_CHANGE_REQUESTED',
  'ROLE_CHANGE_DECIDED',
  'ASSEMBLY_REPORT_DAY_EMAILED',
  // Modul „Verbesserungen" (ADR 0078)
  'FEEDBACK_SUBMITTED',
  'FEEDBACK_NEEDS_INFO',
  'FEEDBACK_COMMENTED',
  'FEEDBACK_STATUS_CHANGED',
  // Logistik: erfasster Transport meldet sich beim Lager (VB-26004)
  'TRANSPORT_PLANNED',
]);
export type NotificationType = z.infer<typeof notificationTypeSchema>;

/** Eine Benachrichtigung, wie sie das Frontend erhält. */
export const notificationResponseSchema = z.object({
  id: z.string().uuid(),
  type: notificationTypeSchema,
  title: z.string(),
  body: z.string(),
  /** Ziel in der SPA beim Klick (z. B. /engineering/antraege). Null = kein Sprungziel. */
  linkPath: z.string().nullable(),
  entityType: z.string().nullable(),
  entityId: z.string().nullable(),
  /** ISO-Zeitstempel des Gelesen-Markierens; null = ungelesen. */
  readAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
});
export type NotificationResponse = z.infer<typeof notificationResponseSchema>;

/** Anzahl ungelesener Benachrichtigungen (für die Glocke im Header). */
export const unreadCountResponseSchema = z.object({ unread: z.number().int().nonnegative() });
export type UnreadCountResponse = z.infer<typeof unreadCountResponseSchema>;
